const localizers = {
  'loading.msg': () => `กำลังโหลด…`,
  'logon.message.msg': () => `ต้องมีการรับรองความถูกต้อง ป้อน ID ผู้ใช้และรหัสผ่านที่ถูกต้อง`,
  'logon.button.msg': () => `เข้าสู่ระบบ...`,
  'SASServer.logonError.msg': () => `ไม่สามารถเข้าสู่ระบบเซิร์ฟเวอร์ได้`,
  'SASServer.genericError.msg': () => `ไม่สามารถเข้าถึงเซิร์ฟเวอร์ได้`,
}
export default localizers;
